import React, { ComponentPropsWithoutRef, forwardRef } from 'react';
import { withStyles } from '../../../utils';
import styles from './Title2.module.scss';

const cn = withStyles(styles);

type TitleProps = ComponentPropsWithoutRef<'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'> & {
  level?: '1' | '2' | '3' | '4' | '5' | '6';
  emphasized?: boolean;
  className?: string;
};

const Title = forwardRef<HTMLHeadingElement, TitleProps>(
  ({ level = '1', emphasized = true, className, children, ...props }, ref) => {
    return React.createElement(
      `h${level}`,
      { ref, className: cn('titleContainer', `level${level}`, emphasized && 'emphasized', className), ...props },
      children,
    );
  },
);

Title.displayName = 'Title';

export default Title;
